import React from 'react';
// import PropTypes from 'prop-types'

/* eslint-disable */
const Loading = props => (
  <div className="loading" />
);

// export const LoadingSpinner = ({ size }) => (
//   <div className={classes.container}>
//     <div className={classes.progress}>
//       <CircularProgress mode='indeterminate' size={size || 80} />
//     </div>
//   </div>
// )
//
// LoadingSpinner.propTypes = {
//   size: PropTypes.number
// }

export default Loading



// WEBPACK FOOTER //
// ./src/components/elements/loading/index.jsx